import { helper } from '@ember/component/helper';
import { numberToUserDisplay } from '@ebiz/pretty-num';
import Constants from '../utils/constants';
import Utils from '../utils/utils';

function prettyNum(params, hash) {
  let options = {};
  const digits = Utils.isNumeric(hash.digits) ? hash.digits : 3;

  if (hash.separatedUnit) options.supplySpace = true;
  if (hash.showZeroes) options.showZeroes = true;
  if (hash.fixedDigits) options.fixedDigits = true;

  return numberToUserDisplay(hash.value, Constants.PRETTY_NUM.ENGINEERING, digits, options);
}

export default helper(prettyNum);
